import type { z } from 'zod'

import { availabilityFormSchema } from '@/constants/availability-form'
import { isDayOfWeek } from '@/constants/days-of-week'
import type { FieldErrorsMapper } from '@/hooks/useMutationWithErrorsHandling'
import type { TimetableSettings } from '@/modules/timetable'
import { labelAndValue } from '@/utils/zod'

export const setUserAvailabilityFormSchema = (
  workingHours: TimetableSettings
) =>
  availabilityFormSchema(workingHours).extend({
    user: labelAndValue().nullable()
  })

export type SetAvailabilityForm = z.infer<
  ReturnType<typeof setUserAvailabilityFormSchema>
>

export type SetAvailabilityPayload = SetAvailabilityForm & {
  userId: string
  semesterId: string
}

export const setAvailabilityErrorsMapper: FieldErrorsMapper<
  SetAvailabilityForm
> = attr => {
  if (isDayOfWeek(attr)) return attr
  const [fieldName, index] = attr.split('.')
  if (!isDayOfWeek(fieldName)) return 'root'
  return `${fieldName}.${Number(index)}.time`
}
